import { mapState } from "vuex";
import Swal from "sweetalert2";

export default {
  computed: {
    ...mapState("cms", {
      pageCategories: "pageCategories",
      filtertags: "filtertags",
      filters: "filters",
      pages: "pages",
      categorywisepages: "categorywisepages",
    }),
    ...mapState("cmsAuthor", {
      author: "author",
    }),
    ...mapState("doctor", {
      doctor: "doctor",
    }),
    ...mapState("auth", { user: "user" }),
    ...mapState("auth", { getUserByUserId: "getUserByUserId" }),
    // displayedPages() {
    //   return this.pages.slice(
    //     (this.currentPage - 1) * this.perPage,
    //     this.currentPage * this.perPage
    //   );
    // },
    total_row() {
      return this.pages.length;
    },
  },
  methods: {
    handleReadMore() {
      // this.$router.push({
      //   name: "blogspage",
      //   params: {
      //     id: this.item._id,
      //     slug: this.item._id,
      //     // slug: this.encodeURIBlog(this.item.title),
      //     category: this.category,
      //   },
      // });
      // console.log(this.categorywisepages.data);
      let clickedBlogId = "";
      if (Object.keys(this.user).length !== 0) {
        this.categorywisepages.data.forEach((element) => {
          if (element._id === this.item._id) {
            if (
              element.memberships != null &&
              element.memberships.length !== 0
            ) {
              clickedBlogId = element.memberships[0]._id;
            }
          }
        });
      }
      // if (Object.keys(this.user).length === 0) {
      //   Swal.fire({
      //     title: "Login",
      //     text: "Please Login to continue viewing the blog",
      //     icon: "warning",
      //     confirmButtonColor: "#830c81",
      //     showConfirmButton: true,
      //   }).then((result) => {
      //     if (result.isConfirmed) {
      //       this.$router.push({ name: "signin" });
      //     }
      //   });
      //   return;
      // }
      if (this.item.onlyRegistered) {
        if (Object.keys(this.user).length === 0) {
          Swal.fire({
            title: "Login",
            text: "To access the content, kindly proceed with registration/login",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showConfirmButton: true,
          });
          this.$router.push({ name: "signin" });
          return;
          //   .then((result) => {
          //   if (result.isConfirmed) {
          //     this.$router.push({ name: "signin" });
          //   }
          // });
        } else if (this.item.onlySubscribed) {
          if (
            this.user.membership != null &&
            this.user.membership.includes(clickedBlogId)
          ) {
            const routeData = this.$router.resolve({
              name: "blogspage",
              params: {
                id: this.item._id,
                // slug: this.item._id,
                slug: this.encodeURIBlog(this.item.title),
                category: this.category,
              },
            });
            window.open(routeData.href, "_blank");
          } else {
            Swal.fire({
              title: "Upgrage Plan",
              text: "Upgrade now for unrestricted access!",
              icon: "info",
              confirmButtonColor: "#830c81",
              confirmButtonText: "Show Plans",
              showConfirmButton: true,
              showCancelButton: true,
            }).then((e) => {
              if (e.isConfirmed) {
                this.$router.push({
                  path: "/subscribe1",
                });
              }
            });
          }
        }
        // else if (Object.keys(this.user).length === 0) {
        //   Swal.fire({
        //     title: "Login",
        //     text: "Please Login to continue viewing the blog",
        //     icon: "warning",
        //     confirmButtonColor: "#830c81",
        //     showConfirmButton: true,
        //   }).then((result) => {
        //     if (result.isConfirmed) {
        //       this.$router.push({ name: "signin" });
        //     }
        //   });
        // }
        else {
          const routeData = this.$router.resolve({
            name: "blogspage",
            params: {
              id: this.item._id,
              // slug: this.item._id,
              slug: this.encodeURIBlog(this.item.title),
              category: this.category,
            },
          });
          window.open(routeData.href, "_blank");
        }
      } else {
        // alert();
        const routeData = this.$router.resolve({
          name: "blogspage",
          params: {
            id: this.item._id,
            // slug: this.item._id,
            slug: this.encodeURIBlog(this.item.title),
            category: this.category,
          },
        });
        window.open(routeData.href, "_blank");
      }
    },
    encodeURIBlog(string) {
      // return encodeURI(string);
      return string.replace(/-/g, "_").replace(/\s/g, "-");
    },
  },
};
